import { ModalProps, Typography } from "antd";

import { Modal } from "@components/Modal";

export const CorbanChangeModal = ({ ...props }: ModalProps) => {
  return (
    <Modal title="Atenção!" cancelText="Não" okText="Sim" {...props}>
      <Typography.Text>
        Ao alterar o correspondente você será redirecionado para a tela inicial,
        deseja prosseguir?
      </Typography.Text>
    </Modal>
  );
};
